import React from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import {
  HrFlexContainer,
  HrTitleContainer,
  HrTitleH4,
  HrButtons,
  HrBlockContainer
} from '@components/styles/hr-styles';
import { Input } from '@components/form/input';
import { Textarea } from '@components/form/textarea';
import { HrButton } from '@components/button/button';
import { Modal } from '../../../postulation_form/components/modal';

export const SendLinkModal = ({ sendLink, setShowModalSendLink, onShowToast, requestLink }) => {
  const [t] = useTranslation();

  const { register, formState, handleSubmit, control } = useForm({
    mode: 'onSubmit',
    defaultValues: {
      sendSubject: t('requestVacancies.colaborativeSelection.modal.sendLink.sendSubject'),
      sendDescription: t('requestVacancies.colaborativeSelection.modal.sendLink.sendDescription')
    }
  });

  const onSubmitSuccess = (data) => {
    sendLink.mutate({ ...data, sendLink: requestLink });
  };

  const onSubmitError = () => {
    onShowToast({
      visible: true,
      type: 'error',
      message: t(`requestVacancies.colaborativeSelection.sendMail.error`)
    });
  };

  return (
    <Modal setShowModal={setShowModalSendLink}>
      <HrTitleContainer padding='32px 32px 12px 32px'>
        <i className='hr-email' />
        <HrTitleH4>{t('requestVacancies.colaborativeSelection.modal.sendLink.title')}</HrTitleH4>
      </HrTitleContainer>
      <HrBlockContainer padding='16px 32px 0 32px'>
        <form id='FormUpdateAccount'>
          <HrFlexContainer gap='16px'>
            <Input
              title={t(`requestVacancies.colaborativeSelection.modal.sendLink.form.sendTo`)}
              placeholder={t(`requestVacancies.colaborativeSelection.modal.sendLink.form.sendToPlaceholder`)}
              name='sendTo'
              type='text'
              register={register}
              formState={formState}
              validate={{
                required: true,
                whiteSpace: true
              }}
            />
            <Input
              title={t(`requestVacancies.colaborativeSelection.modal.sendLink.form.sendSubject`)}
              placeholder={t(`requestVacancies.colaborativeSelection.modal.sendLink.form.sendSubjectPlaceholder`)}
              name='sendSubject'
              type='text'
              register={register}
              formState={formState}
              validate={{
                required: true,
                whiteSpace: true
              }}
            />
            <Textarea
              title={t('requestVacancies.colaborativeSelection.modal.sendLink.form.sendDescription')}
              id='sendDescription'
              register={register}
              formState={formState}
              placeholder={t('requestVacancies.colaborativeSelection.modal.sendLink.form.sendDescriptionPlaceholder')}
              control={control}
              validate={{
                required: true
              }}
            />
          </HrFlexContainer>
        </form>
      </HrBlockContainer>
      <HrFlexContainer padding='32px' justifyContent='space-between'>
        <HrButtons
          type='button'
          category='cancel'
          size='medium'
          onClick={() => {
            setShowModalSendLink(false);
          }}
        >
          {t('general.button.close')}
        </HrButtons>
        <HrButton
          type='button'
          category='primary'
          size='medium'
          onClick={handleSubmit(onSubmitSuccess, onSubmitError)}
          loading={sendLink.isLoading}
          disabled={sendLink.isLoading}
          text={t('general.button.send')}
          name={t('general.button.send')}
        />
      </HrFlexContainer>
    </Modal>
  );
};
